import { render, staticRenderFns } from "./ProspectInvite.vue?vue&type=template&id=a6a57754&scoped=true&"
import script from "./ProspectInvite.vue?vue&type=script&lang=js&"
export * from "./ProspectInvite.vue?vue&type=script&lang=js&"
import style0 from "./ProspectInvite.vue?vue&type=style&index=0&id=a6a57754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a57754",
  null
  
)

export default component.exports